/**
 * Where one tool call stands, as an execution state: done or failed once its result arrived
 * (a result with `success: false` failed), running while the run still works on it, and failed
 * when the run ended without a result for it.
 */
const resolveToolStepState = ({ item, isRunInProgress }) => {
  const result = item?.toolArgs?.result;

  if (item?.completed === true) {
    return result && typeof result === 'object' && result.success === false ? 'failed' : 'done';
  }

  return isRunInProgress ? 'running' : 'failed';
};

export default resolveToolStepState;
